// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1g2vO","row":"ProcedureTreatmentSummary_row__37Qay"};